import React from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';

import { SecureTabs, SignatureSettings } from '../../../components';
import { Preloader, ToDashboardError } from '../../../components/ui';
import { useCurrentProject } from '../../../contexts/settings';
import { RouteParams } from '../../../routes/types';

const SignaturePage = ({ match }: RouteComponentProps): JSX.Element => {
  const { projectId } = match.params as RouteParams;
  const { currentProjectFetching, currentProject, updateCurrentProject, error } =
    useCurrentProject(projectId);

  if (currentProjectFetching) {
    return <Preloader />;
  }

  if (error) {
    return <ToDashboardError error={error} pageName="signature-settings_open" />;
  }

  return (
    <SecureTabs>
      <SignatureSettings
        currentProject={currentProject}
        updateCurrentProject={updateCurrentProject}
      />
    </SecureTabs>
  );
};

export default withRouter(SignaturePage);
